import { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle, Printer, X } from "lucide-react";
import { useSignature } from "@/components/SignatureModal";
import { buildStatementText, sendWhatsApp } from "@/lib/whatsapp";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const money = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);
const MONTHS = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

export const StatementModal = ({ tither, year, onClose }) => {
  const [st, setSt] = useState(null);
  const [sig] = useSignature(tither.church);
  useEffect(() => {
    const p = new URLSearchParams({ name: tither.name, church: tither.church, year });
    axios.get(`${API}/tithers/statement?${p}`, { withCredentials: true }).then(r => setSt(r.data));
  }, [tither, year]);
  return <div className="modal-backdrop receipt-backdrop"><div className="modal receipt-modal" data-testid="statement-modal">
    <div className="receipt-toolbar no-print">
      <button data-testid="statement-print-button" className="primary-btn compact" onClick={() => window.print()}><Printer size={16} /> Imprimir comprovante</button>
      {st && <button data-testid="statement-whatsapp-button" className="whatsapp-btn compact" onClick={() => sendWhatsApp({ phone: tither.phone, text: buildStatementText(st), withBanner: false })}><MessageCircle size={16} /> Enviar no WhatsApp</button>}
      <button data-testid="statement-close-button" className="icon-btn" onClick={onClose}><X /></button>
    </div>
    {!st ? <p className="empty">Carregando comprovante...</p> : <article className="receipt" data-testid="statement-content">
      <header className="receipt-head">
        <img src="/logo-adsa-dark.png" alt="ADSA Brasil" />
        <div><strong>ADSA BRASIL</strong><span>Campo de Parelheiros · {st.church}</span></div>
        <div className="receipt-no"><span>COMPROVANTE ANUAL</span><b>{st.year}</b></div>
      </header>
      <p className="receipt-text">Declaramos, para os devidos fins, que <b data-testid="statement-name">{st.name}</b> entregou dízimos à igreja {st.church} durante o ano de {st.year}, conforme abaixo:</p>
      <table className="receipt-table"><tbody>
        {MONTHS.map((m, i) => <tr key={m}><td>{m}</td><td>{st.months[i] ? money(st.months[i]) : "—"}</td></tr>)}
        <tr className="receipt-total"><td>Total no ano ({st.count} dízimo{st.count === 1 ? "" : "s"})</td><td data-testid="statement-total">{money(st.total)}</td></tr>
      </tbody></table>
      <p className="receipt-verse">"Trazei todos os dízimos à casa do tesouro" — Malaquias 3:10</p>
      <footer className="receipt-sign single"><div className="sign-slot">{sig.url && <img data-testid="statement-signature-image" src={sig.url} alt="Assinatura do tesoureiro" />}<span />Tesouraria{sig.treasurer_name ? ` · ${sig.treasurer_name}` : ""}</div></footer>
      <p className="receipt-issued">Emitido em {new Date().toLocaleDateString("pt-BR")}</p>
    </article>}
  </div></div>;
};
